const convertBytesToMB = (bytes: number) => {
  const MBs = bytes / 1024 / 1024;

  return MBs.toFixed(2);
};

export { convertBytesToMB };
